import config from 'config';

import { useIntl } from '../../../../techstyle-shared/react-intl';

export type useCdnImagePathOptions = {
  cdnBaseUrl?: string;
};

export default function useCdnImagePath(options: useCdnImagePathOptions = {}) {
  let { cdnBaseUrl } = options;
  if (!cdnBaseUrl) {
    if (!cdnBaseUrl && config.has('public.cdn')) {
      cdnBaseUrl = config.get('public.cdn');
    } else if (!cdnBaseUrl && config.has('public.cdn')) {
      cdnBaseUrl = config.get('public.cdn');
    } else {
      cdnBaseUrl = '';
    }
  }

  const intl = useIntl();
  const getCdnRootPath = (path: string) => {
    return `${cdnBaseUrl}/${path}`;
  };
  const getCdnImagePath = ({
    path,
    localize = 'global',
    folder,
    suffix = '',
    extension = '.jpg',
  }: {
    path: string;
    localize?: string | boolean;
    folder?: string;
    suffix?: string;
    extension?: string;
  }) => {
    if (localize === true) {
      localize = intl.locale.replace('-', '_');
    }
    return getCdnRootPath(
      `media/images/${localize ? `${localize}/` : ''}${
        folder ? `${folder}/` : ''
      }${path}${suffix}${extension}`
    );
  };
  return {
    cdnBaseUrl,
    getCdnImagePath,
    getCdnRootPath,
  };
}
